'use strict';

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.enable');
    reader.readUInt8('data.params.second');
    reader.readUInt8('data.params.minute');
    reader.readUInt8('data.params.hour');
    reader.readUInt8('data.params.day');
    reader.readUInt8('data.params.month');
    reader.readUInt16LE('data.params.year');
    reader.readUInt8('data.params.week');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/alarm-condition-parser.js